import { IconType } from "react-icons";
import PropTypes from "prop-types";

interface IconStar {
    icon: IconType;
    size: number;
    color?: string;
}

const IconComponent: React.FC<IconStar> = ({ icon, size, color }) => {
    const IconElement = icon as React.ElementType;
    return <IconElement size={size} color={color} />;
};

IconComponent.propTypes = {
    icon: PropTypes.func.isRequired,
};

export default IconComponent;